import type { AccountStatsRow, SortDirection, SortKey } from '../types/account-stats';

export function sortRows(
  rows: AccountStatsRow[],
  key: SortKey,
  dir: SortDirection
): AccountStatsRow[] {
  return [...rows].sort((a, b) => {
    const aVal = a[key] as string | number | null;
    const bVal = b[key] as string | number | null;

    if (aVal === null && bVal === null) return 0;
    if (aVal === null) return 1;
    if (bVal === null) return -1;

    if (typeof aVal === 'string' && typeof bVal === 'string') {
      const cmp = aVal.localeCompare(bVal, 'ru');
      return dir === 'asc' ? cmp : -cmp;
    }

    const cmp = (aVal as number) - (bVal as number);
    return dir === 'asc' ? cmp : -cmp;
  });
}
